module.exports = new __parcel__URL__("Software Arch Review.77a3a9da.svg").toString();